import { strings } from '../strings';

export function Pagination({
  page,
  totalPages,
  onChange,
}: {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}) {
  if (totalPages <= 1) return null;
  return (
    <nav aria-label="Pagination" className="mt-6 flex flex-wrap items-center gap-4">
      <button type="button" className="btn-secondary" disabled={page <= 1} onClick={() => onChange(page - 1)}>
        {strings.pagination.previous}
      </button>
      <span aria-live="polite">{strings.pagination.page(page, totalPages)}</span>
      <button type="button" className="btn-secondary" disabled={page >= totalPages} onClick={() => onChange(page + 1)}>
        {strings.pagination.next}
      </button>
    </nav>
  );
}
